import React from 'react';
import PropTypes from 'prop-types'; 
import { Skeleton, Row, Col,Typography } from 'antd';
import styled from 'styled-components';

const { Title } = Typography;

const TitleWrapper = styled(Title)(
  () => `
    height: 48px;
    background: #f8f9fa;
`
);

const AddCarTitleTypeSkeleton = ({ avatarSize = "large", inputWidth = 180, inputHeight = 75, inputSize = "large", gutter = 24, padding = '18px 0px', backgroundColor = '#fff', align = 'center', borderRadius= '10px' }) => {
  return (
    <div style={{ textAlign: align, backgroundColor }}>
      <TitleWrapper level={3} />
      <Row gutter={gutter} justify="center" style={{padding}}>
        <Col>
          <Skeleton.Input style={{ width: inputWidth, height: inputHeight, borderRadius: borderRadius }} active size={inputSize} />
        </Col>
        <Col>
          <Skeleton.Input style={{ width: inputWidth, height: inputHeight, borderRadius: borderRadius }} active size={inputSize} />
        </Col>
      </Row>
    </div>
  );
};

AddCarTitleTypeSkeleton.propTypes = {
  avatarSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputSize: PropTypes.string,
  gutter: PropTypes.number,
  padding: PropTypes.string,
  backgroundColor: PropTypes.string,
  align: PropTypes.string,
  borderRadius: PropTypes.string,
};

export default AddCarTitleTypeSkeleton;
